/* wcc-track-calc.js
 * Sizing-tool measurement, quote intent, and email capture.
 *
 * Follows the event contract set in snippets/wcc-assistant.liquid: a real gtag
 * event (GA4 G-4PP1STXJ4F plus the AW- targets), a dataLayer copy so a later GTM
 * move is painless, and a Klaviyo metric. Everything is passive, capture-phase,
 * and inert when gtag/Klaviyo are absent.
 *
 * Events:
 *   tool_completed     a sizing result was produced
 *   add_to_quote       the built quote was committed to the cart
 *   clicked_quote_cta  extended to calculator links and assistant chips
 *   email_signup       a visitor opted in to the list from the quote form
 */
(function () {
  'use strict';

  var KLAVIYO_COMPANY = 'VhHzAe';
  var KLAVIYO_LIST = 'TnFnNN';

  function push(name, props) {
    props = props || {};
    props.page_url = location.href;
    props.page_title = document.title;
    try {
      if (typeof window.gtag === 'function') {
        var gn = name.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
        window.gtag('event', gn, props);
      }
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      var d = { event: name };
      for (var k in props) { if (Object.prototype.hasOwnProperty.call(props, k)) { d[k] = props[k]; } }
      window.dataLayer.push(d);
    } catch (e) {}
    try {
      if (window.klaviyo && typeof window.klaviyo.track === 'function') { window.klaviyo.track(name, props); }
    } catch (e) {}
  }

  /* ---- quote intent the site-wide listener cannot match ------------------ */
  var EXISTING = '[data-quote-cta], .wcc-quote-cta, [data-notify]';
  var EXTRA = 'a[href*="cellar-cooling-calculator"], #wccai-chips [data-chip]';

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var hit = t.closest(EXTRA);
    if (!hit || hit.closest(EXISTING)) { return; }
    var label = (hit.getAttribute('data-chip') || hit.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80);
    push('Clicked Quote CTA', {
      label: label,
      source: hit.hasAttribute('data-chip') ? 'assistant-chip' : 'calculator-link'
    });
  }, true);

  /* ---- the sizing tool -------------------------------------------------- */
  function initTool() {
    var form = document.getElementById('WccQuoteForm');
    var out = document.getElementById('WccQuoteOut');
    if (!form || !out) { return; }

    var submit = form.querySelector('.calc-submit');
    if (submit && !submit.hasAttribute('data-quote-cta')) {
      submit.setAttribute('data-quote-cta', 'Build my quote');
    }

    function field(q) {
      var el = form.querySelector('[data-q="' + q + '"]');
      if (!el) { return ''; }
      if (el.type === 'checkbox') { return el.checked ? 'yes' : 'no'; }
      return (el.value || '').trim();
    }

    var lastSig = '';
    function check() {
      if (out.hidden || out.innerHTML.length < 200) { return; }
      var sig = [field('length'), field('width'), field('height'), field('ambient'),
                 field('glass'), field('bottles'), out.innerHTML.length].join('|');
      if (sig === lastSig) { return; }
      lastSig = sig;
      var vol = (parseFloat(field('length')) || 0) *
                (parseFloat(field('width')) || 0) *
                (parseFloat(field('height')) || 0);
      push('Tool Completed', {
        tool: 'cellar-cooling-calculator',
        cellar_cubic_feet: Math.round(vol),
        glass: field('glass'),
        vapor_barrier: field('vapor'),
        bottles: field('bottles') || 'not given'
      });
    }

    new MutationObserver(check).observe(out, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['hidden']
    });
    check();

    /* Selectors confirmed against the live result markup on 2026-09-15: the
       commit control is button.calc-quote-add[data-addquote]. */
    out.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) { return; }
      var add = t.closest('[data-addquote], .calc-quote-add, [data-add], [data-accessory], a[href*="/cart/add"], .calc-pick-add');
      if (!add) { return; }
      var picked = out.querySelector('input[type="radio"]:checked');
      var pickedName = '';
      if (picked) {
        var row = picked.closest('li, tr, div');
        var link = row && row.querySelector('a');
        pickedName = link ? (link.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80) : '';
      }
      push('Add To Quote', {
        tool: 'cellar-cooling-calculator',
        label: (add.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60) || 'unlabelled',
        unit: pickedName || 'not identified',
        accessories: out.querySelectorAll('input[type="checkbox"]:checked').length
      });
    }, true);
  }

  /* ---- email capture ----------------------------------------------------
   * Klaviyo held ONE form, in draft since 2020, so the site had no way to take
   * an email and the list gained nobody for 15 straight weeks. This adds a
   * capture at the highest-intent moment on the site: somebody who has just
   * sized their cellar and asked for the quote by email.
   *
   * Opt-in only. The box starts unchecked, the quote is sent either way, and
   * nothing subscribes without a tick. Uses Klaviyo's client subscriptions
   * endpoint, which is built for browser use with the public company id and
   * records real consent, rather than identify(), which would create a profile
   * with no consent attached to it.
   */
  function initCapture() {
    var form = document.getElementById('WccQuoteNotify');
    if (!form || form.getAttribute('data-capture-ready')) { return; }
    var email = form.querySelector('input[type="email"], input[name="contact[email]"]');
    if (!email) { return; }
    form.setAttribute('data-capture-ready', '1');

    var wrap = document.createElement('label');
    wrap.className = 'wcc-optin';
    wrap.setAttribute('style', 'display:flex;align-items:flex-start;gap:.55rem;margin:.75rem 0;font-size:13px;line-height:1.45;cursor:pointer');

    var box = document.createElement('input');
    box.type = 'checkbox';
    box.id = 'WccOptIn';
    box.checked = false;
    box.setAttribute('style', 'margin-top:.2rem;flex:none');

    var txt = document.createElement('span');
    txt.textContent = 'Also send me occasional cellar cooling guidance. A few emails a year, unsubscribe any time.';

    wrap.appendChild(box);
    wrap.appendChild(txt);

    /* querySelector resolves a selector LIST in document order, so the old
       combined query matched #WccSendLead (the card heading, which renders
       first) and the opt-in landed above the heading. Query the submit
       control on its own; the others are fallbacks, tried in order. */
    var anchor = form.querySelector('button[type="submit"], input[type="submit"]') ||
                 form.querySelector('.calc-send') ||
                 form.querySelector('#WccSendLead');
    if (anchor && anchor.parentNode) { anchor.parentNode.insertBefore(wrap, anchor); }
    else { form.appendChild(wrap); }

    form.addEventListener('submit', function () {
      if (!box.checked) { return; }
      var addr = (email.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(addr)) { return; }
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Cellar Cooling Calculator',
            profile: {
              data: {
                type: 'profile',
                attributes: { email: addr, properties: { lead_source: 'Cellar Cooling Calculator' } }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST } } }
        }
      };
      try {
        /* keepalive so the request survives the form's own navigation */
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY, {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify(payload)
        }).catch(function () {});
      } catch (e) {}
      push('Email Signup', { source: 'cellar-cooling-calculator', double_opt_in: 'yes' });
    }, false);
  }

  function boot() { initTool(); initCapture(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* The notify block renders from layout after content_for_layout, so retry
     once on full load in case it lands late. */
  window.addEventListener('load', initCapture);
})();
